import { styled as t } from "styled-components";
import { SmartLink as o } from "../SmartLink/index.js";
const e = t(o)`
  text-decoration: none;
  display: contents;
`;
export {
  e as CustomLink
};
